   // components/Header.js
   import React from 'react';
   import './Header.css';

   const Header = ({ title, table }) => {
     return (
       <div className="header-container">
         <h1>{title}</h1>
         <div className="table-container">
           {table}
         </div>
       </div>
     );
   };

  

   export default Header;